<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  fa?: string;
  name?: string;
  icon?: string;
  fontScale?: number;
  color?: string;
  clickable?: boolean;
  tooltip?: string;
}>();

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void;
}>();

const resolvedIcon = computed(() => props.icon || props.name);

const isFaColonIcon = computed(() => {
  const icon = resolvedIcon.value;
  return icon && icon.startsWith('fa:');
});

const isIconifyIcon = computed(() => {
  const icon = resolvedIcon.value;
  return icon && icon.indexOf(':') > -1 && !isFaColonIcon.value;
});

const faClassName = computed(() => {
  const icon = resolvedIcon.value;
  if (icon && icon.startsWith('fa:')) {
    const iconName = icon.substring(3);
    return `fas fa-${iconName}`;
  }
  if (icon && icon.startsWith('fa-')) {
    return `fas ${icon}`;
  }
  if (props.fa) {
    return `fas fa-${props.fa}`;
  }
  return null;
});

const iconStyle = computed(() => {
  const result: Record<string, string> = {};
  if (props.fontScale) {
    result['font-size'] = `${props.fontScale}em`;
  }
  if (props.color) {
    result['color'] = props.color;
  }
  if (props.clickable) {
    result['cursor'] = 'pointer';
  }
  return result;
});

function onClick(event: MouseEvent) {
  if (props.clickable) {
    emit('click', event);
  }
}
</script>

<template>
  <iconify-icon
    v-if="isIconifyIcon"
    v-b-tooltip="tooltip ? { title: tooltip } : undefined"
    noobserver
    :icon="resolvedIcon"
    :style="iconStyle"
    :title="tooltip"
    @click="onClick"
  />
  <i
    v-else-if="faClassName"
    v-b-tooltip="tooltip ? { title: tooltip } : undefined"
    :class="faClassName"
    :style="iconStyle"
    :title="tooltip"
    @click="onClick"
  />
</template>
